var _excluded = ["children"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { createContext, useContext } from "react";
import h from "@macrostrat/hyper";
var IndexingContext = /*#__PURE__*/createContext(null);

function IndexingProvider(props) {
  var children = props.children,
      value = _objectWithoutProperties(props, _excluded);

  return h(IndexingContext.Provider, {
    value: value
  }, children);
}

var useIndexing = function useIndexing() {
  return useContext(IndexingContext);
};

export { IndexingProvider, useIndexing };